import React from 'react';
import '../css/home.css'; // Common styles for info blocks
import { formatNumberWithCommas } from '../components/formatIntegerWithCommas.js'
import { t } from 'ttag';
import ProgressBar from './ProgressBar'; // Убедитесь, что путь правильный

function Home({ recData, handlesetIndex }) {

    // --- Лицензии ---
    const lic_arr = recData.user_lic.map((element, index) => (
        <div className='h-sub-block' key={index}>
            <div className='h-data-row'>
                <div className="l-data-label" style={{ width: "auto" }}>{element.name}  {element.active == 0 ? '(PAUSE)' : ''}</div>
                <div className="l-data-value">
                    {formatNumberWithCommas(element.profit, 2)} / {formatNumberWithCommas(element.price, 2)} USDT
                </div>
            </div>
            <ProgressBar
                completed={element.active == 0 ? 100 : ((element.profit) / element.price) * 100}
                bgColor="#2196f3" // Этот цвет теперь будет работать
                height="10px"
            />
        </div>
    ));


    // --- Баланс ---
    const bal = (
        <div className="h-balance-container">
            <div className="h-info-block">
                <div className="h-info-block-header">{t`Balance`}</div>
                <div className="h-info-block-value">{formatNumberWithCommas(parseFloat(recData.usdt), 4)} USDT</div>
            </div>
            <button className="h-balance-button" onClick={() => { handlesetIndex(3) }}>
                {t`i`}
            </button>
        </div>
    );

    // --- Блок Лицензий ---
    const lic = (
        <div className='h-main-block'>
            <div className='h-block-title'>{t`License`}</div>
            <div className='h-data-row'>
                <div className='h-data-label'>{t`License Pool`}</div>
                <div className='h-data-value' style={{ color: '#4cdf4c' }}>{formatNumberWithCommas(recData.lic_pool, 0)} USDT</div>
            </div>
            <div className='h-data-row'>
                <div className='h-data-label'>{t`Active License:`}</div>
                <div className='h-data-value'> {recData.user_lic.length === 0 ? "No" : ""}</div>
            </div>
            <div className='h-license-list'>
                {lic_arr}
            </div>
        </div>
    );

    // --- Блок Торговли ---
    const tradeDeposit = recData.trade_balance;
    const tradeProfit = recData.trade_profit;
    const makc_pool = recData.akc_pool;

    const trd = (
        <div className='h-main-block'>
            <div className='h-block-title'>{t`Trade`}</div>
            <div className='h-data-row'>
                <div className='h-data-label'>{t`Trade Balance:`}</div>
                <div className='h-data-value'>{formatNumberWithCommas(tradeDeposit, 2)} USDT</div>
            </div>
            <div className='h-data-row'>
                <div className='h-data-label'>{t`Profit:`}</div>
                <div className='profit h-data-value '>{formatNumberWithCommas(tradeProfit, 2)} USDT</div>
            </div>
        </div>
    );

    // --- Блок Прибыли (Редизайн) ---
    const prft = (
        <div className='h-main-block h-profit-block'>
            <div className='h-block-title'>{t`Profit`}</div>

            {/* Главное значение */}
            <div className="h-info-block-header">{t`Total profit:`}</div>
            <div className="h-info-block-value">
                {formatNumberWithCommas(recData.lic_profit || 0 + recData.trade_profit || 0 + recData.ref_profit || 0, 2)} USDT
            </div>

            {/* Детализация */}
            <div className='h-data-row h-profit-details'>
                <div className='h-data-label'>{t`Trade profit:`}</div>
                <div className='profit h-data-value'>{formatNumberWithCommas(recData.trade_profit || 0, 2)} USDT</div>
            </div>
            <div className='h-data-row h-profit-details'>
                <div className='h-data-label'>{t`License profit:`}</div>
                <div className='profit h-data-value'>{formatNumberWithCommas(recData.lic_profit || 0, 2)} USDT</div>
            </div>
            <div className='h-data-row h-profit-details'>
                <div className='h-data-label'>{t`Referral profit:`}</div>
                <div className='profit h-data-value'>{formatNumberWithCommas(recData.ref_profit || 0, 2)} USDT</div>
            </div>
        </div>
    );

    const akc_pool = (
        <div className='h-main-block'>
            <div className='h-block-title'>{t`Marketing`}</div>
            <div className='h-data-row'>
                <div className='h-data-label'>{t`Pool:`}</div>
                <div className='h-data-value'>{formatNumberWithCommas(makc_pool, 2)} USDT</div>
            </div>
        </div>
    );

    return (
        <>
            {bal}
            {prft}
            {akc_pool}
            {lic}
            {trd}
        </>
    );
}

export { Home };